import React, { useRef, useState } from 'react';
type CarouselProps = {
  children: React.ReactNode[];
  label: string;
};
export function Carousel({
  children,
  label
}: CarouselProps) {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const handleScroll = () => {
    const el = trackRef.current;
    if (!el) return;
    const slide = el.scrollWidth / children.length;
    setActive(Math.round(el.scrollLeft / slide));
  };
  const goTo = (i: number) => {
    const el = trackRef.current;
    if (!el) return;
    const slide = el.scrollWidth / children.length;
    el.scrollTo({
      left: slide * i,
      behavior: 'smooth'
    });
  };
  return <div data-id="element-42" data-mp="28gopruag5q5o">
      <ul ref={trackRef} onScroll={handleScroll} aria-label={label} className="-mx-4 flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth px-4 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-43" data-mp="23jya382k0wks">
        {children.map((child, i) => <li key={i} className="w-[86%] flex-none snap-center" aria-roledescription="slide" aria-label={`${i + 1} de ${children.length}`} data-id="element-44" data-mp="2h28rzoyi5bac" data-mpi={i}>
            {child}
          </li>)}
      </ul>

      <div className="mt-3 flex justify-center gap-1.5" data-id="element-45" data-mp="2r1r97xn12iyp">
        {children.map((_, i) => <button key={i} type="button" onClick={() => goTo(i)} aria-label={`Ir a ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === active ? 'w-5 bg-orange-400' : 'w-1.5 bg-white/25'}`} data-id="element-46" data-mp="2v0qbtblae3mz" data-mpi={i} />)}
      </div>
    </div>;
}